<template>
  <div class="line-items-buttons">
    <button
      type="button"
      class="btn btn-primary ihjoz-button"
      @click="addNewLineItem()">
      <i class="demo-icon icon-plus" />
      Item
    </button>
    <button
      type="button"
      class="btn ihjoz-button"
      :class="discountButtonClass"
      @click="toggleDiscount($event)">
      <i class="demo-icon" :class="discountButtonIcon" />
      Discount
    </button>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";

export default {
  computed: {
    ...mapFields("lineItems", [
      "discountEnabled"
    ]),

    discountButtonIcon () {
      return this.discountEnabled ? "icon-times" : "icon-plus";
    },

    discountButtonClass () {
      return this.discountEnabled ? "btn-outline-primary" : "btn-primary";
    }
  },

  methods: {
    ...mapActions("lineItems", [
      "addNewLineItem"
    ]),

    toggleDiscount (e) {
      e.preventDefault();

      this.discountEnabled = !this.discountEnabled;
    }
  }
};
</script>
